var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { classNames, renderIcon } from '../../../../utils';
import { Avatar } from '../../../avatar/avatar';
import { RoundIcon } from '../../../round-icon/round-icon';
import Typography from '../../../typography/typography';
import UserAvatar from '../../../user-avatar/user-avatar';
import * as stackedListStyles from '../../stacked-list.styles';
import * as styles from './user-alert-list-item.styles';
export var UserAlertListItem = function (_a) {
    var _b;
    var item = _a.item, onClickItem = _a.onClickItem;
    var hasClickHandler = (!!onClickItem || !!item.onActionClick) && !item.noClick;
    var renderAvatar = useMemo(function () {
        var _a;
        if (item.icon) {
            return (_jsx(RoundIcon, { className: "mr-4", imageUrl: item.icon, hexBackgroundColor: item.avatarColor }));
        }
        if (item.profileDataUrl) {
            return (_jsx(Avatar, { className: "mr-4", size: 'md-lg', dataUrl: item.profileDataUrl, displayBorder: true, borderColor: item.avatarColor }));
        }
        return (_jsx(UserAvatar, { className: "mr-4", size: 'md', avatarColor: item.avatarColor, text: (_a = item.profileText) !== null && _a !== void 0 ? _a : '', displayBorder: true }));
    }, []);
    return (_jsx("div", __assign({ className: (item === null || item === void 0 ? void 0 : item.successColor)
            ? styles.menuItemIconContainerCoachCirclesNoAction
            : hasClickHandler
                ? styles.menulistItemContainer
                : styles.menuItemIconContainerNoAction, id: item.id, onClick: function () {
            if (!item.noClick) {
                if (!!item.onActionClick)
                    item.onActionClick();
                else if (onClickItem)
                    onClickItem(item);
            }
        } }, { children: _jsxs("div", __assign({ className: styles.contentWrapper }, { children: [_jsxs("div", __assign({ className: stackedListStyles.textRowsWrapper }, { children: [!(item === null || item === void 0 ? void 0 : item.hideAvatar) && _jsx("div", { children: renderAvatar }), _jsx("div", __assign({ className: stackedListStyles.paragraphWrapper }, { children: _jsxs("div", { children: [_jsx(Typography, { className: "truncate", type: "h4", weight: "bold", color: "textMid", text: item.title }), _jsxs("div", __assign({ className: styles.menuSubTitle }, { children: [!item.hideAlertSeverity ? (item.alertSeverityNoneIcon &&
                                                item.alertSeverity === 'none' ? (renderIcon(item.alertSeverityNoneIcon, classNames('w-4 h-4', item.alertSeverityNoneColor &&
                                                "text-".concat(item.alertSeverityNoneColor)))) : (_jsx("div", { className: styles.getShapeClassByAlertSeverity(item.alertSeverity) }))) : null, _jsx(Typography, { className: (item === null || item === void 0 ? void 0 : item.breaksSubtitleLine)
                                                    ? 'w-11/12 break-words pl-1'
                                                    : 'truncate pl-1', type: "help", weight: "skinny", color: styles.getColourByAlertSeverity(item.alertSeverity), text: (_b = item.subTitle) !== null && _b !== void 0 ? _b : '' })] }))] }) }))] })), _jsxs("div", __assign({ className: "flex items-center" }, { children: [(item === null || item === void 0 ? void 0 : item.subItem) && (_jsx("p", __assign({ className: 'bg-primary mr-6 truncate rounded-3xl px-2 py-1 text-base font-medium text-white' }, { children: item === null || item === void 0 ? void 0 : item.subItem }))), hasClickHandler &&
                            renderIcon(!!item.rightIcon ? item.rightIcon : 'ChevronRightIcon', styles.menuChevron)] }))] })) })));
};
export default UserAlertListItem;
//# sourceMappingURL=user-alert-list-item.js.map